import type { AuthTokens } from '@data';
import { handleDialogAuthError, handleError } from '@utils-global';

type ProcessLoginMessageParams = {
  closeDialog: () => void;
  onTokens: (tokens: AuthTokens) => void;
  args: { message: string; origin: string };
  showToast: (translationKey: string, options?: any) => void;
};

export const processLoginMessage = async ({
  args,
  showToast,
  onTokens,
  closeDialog,
}: ProcessLoginMessageParams) => {
  try {
    closeDialog();
    const messageFromDialog = JSON.parse(args.message);

    if (messageFromDialog.status === 'success') {
      const { accessToken, idToken } = messageFromDialog.result;
      onTokens({ graphToken: accessToken, idToken });
    } else {
      // Handle all non-success scenarios (admin consent, failures, unknown statuses)
      handleDialogAuthError(messageFromDialog, showToast);
    }
  } catch (error) {
    handleError(error, () => showToast('errors.fallback.general'));
  }
};
